/* Magic City - real "Helpful" votes on product reviews.
   The buttons are rendered by snippets/product_reviews.liquid: desktop list + mobile slider + mobile drawer,
   each one lists the reviews in the same order. window.MC_HELPFUL_IDS (from snippets/mc-helpful.liquid) is the
   list of review handles in that order, so button number i belongs to review i % ids.length.
   Votes are stored by the Cloudflare Worker "magiccity-helpful" (window.MC_HELPFUL_API). */
(function () {
  'use strict';
  var API = window.MC_HELPFUL_API;
  var ids = window.MC_HELPFUL_IDS || [];
  if (!API || !ids.length || window.__mcHelpful) return;
  window.__mcHelpful = true;

  var KEY = 'mc_helpful_voted';
  var voted = {};
  try {
    (JSON.parse(localStorage.getItem(KEY)) || []).forEach(function (id) { voted[id] = 1; });
  } catch (e) {}
  function saveVoted() {
    try { localStorage.setItem(KEY, JSON.stringify(Object.keys(voted))); } catch (e) {}
  }

  var byId = {};  // review handle -> [{ btn, base }]
  var votes = {}; // review handle -> real votes counted by the Worker

  function collect() {
    var all = Array.prototype.filter.call(document.querySelectorAll('button'), function (b) {
      return /^Helpful\s*\(\s*\d+\s*\)$/.test(b.textContent.replace(/\s+/g, ' ').trim());
    });
    // Buttons always come in complete groups of ids.length; anything else = unknown markup, leave it alone.
    if (!all.length || all.length % ids.length) return false;
    all.forEach(function (btn, i) {
      var id = ids[i % ids.length];
      var base = parseInt(btn.textContent.replace(/[^0-9]/g, ''), 10) || 0;
      btn.setAttribute('data-mc-helpful', id);
      (byId[id] = byId[id] || []).push({ btn: btn, base: base });
    });
    return true;
  }

  function paint(entry, id) {
    var n = entry.base + (votes[id] || 0);
    var b = entry.btn;
    var label = null;
    var divs = b.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      if (/Helpful/.test(divs[i].textContent)) label = divs[i];
    }
    if (label) {
      label.textContent = 'Helpful (' + n + ')';
    } else {
      for (var c = b.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3 && /Helpful/.test(c.nodeValue)) c.nodeValue = ' Helpful (' + n + ') ';
      }
    }
    var on = !!voted[id];
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.style.background = on ? '#f0f0f0' : '';
    b.style.cursor = on ? 'default' : 'pointer';
  }
  function paintId(id) { (byId[id] || []).forEach(function (e) { paint(e, id); }); }
  function paintAll() { Object.keys(byId).forEach(paintId); }

  function loadCounts() {
    fetch(API + '/counts?ids=' + encodeURIComponent(Object.keys(byId).slice(0, 50).join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        Object.keys(d).forEach(function (id) { votes[id] = Math.max(votes[id] || 0, d[id] | 0); });
        paintAll();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mc-helpful]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var id = b.getAttribute('data-mc-helpful');
    if (voted[id]) return;
    voted[id] = 1;
    saveVoted();
    votes[id] = (votes[id] || 0) + 1;
    paintId(id);
    fetch(API + '/vote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.counted) votes[id] = d.count;
        else votes[id] = Math.max(0, votes[id] - 1); // server did not count it (already voted from this network)
        paintId(id);
      })
      .catch(function () {
        delete voted[id];
        saveVoted();
        votes[id] = Math.max(0, votes[id] - 1);
        paintId(id);
      });
  }, true);

  function start() {
    if (!collect()) return false;
    paintAll();
    if (window.requestIdleCallback) window.requestIdleCallback(loadCounts, { timeout: 3000 });
    else setTimeout(loadCounts, 300);
    return true;
  }
  if (!start()) window.addEventListener('load', start, { once: true });
})();
